/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of shares (patients) to display or load shares */


(function () {
  'use strict';
  angular.module('vcutils.vcshare')
    .component('sharelist', {
      restrict: 'E',
      bindings: {
        shares: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
            <tr>
              <th width="10%">Name</th>
              <th width="30%">Beschreibung</th>
              <th width="30%">Pfad</th>
              <th width="15%">Filetype</th>
              <th width="15%"></th>
            </tr>
          </thead>
          <tr ng-repeat="share in vm.shares">
            <td ng-bind="share.name"></td>
            <td ng-bind="share.desc"></td>
            <td ng-bind="share.path"></td>
            <td ng-bind="share.filetype"></td>
            <td>
              <span class="btn btn-primary btn-sm" ng-click="vm.editShare(share)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></span><!--
              --><span class="btn btn-danger btn-sm" ng-click="vm.removeShare(share)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></span>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Share', 'ShareHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Share, ShareHelper, vertxEventBusService) {
          let vm = this;
          vm.editShare = ShareHelper.editShare;
          vm.removeShare = removeShare;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve share list from web
            if (angular.isUndefined(vm.shares)) {
              vm.shares = Share.$search({active: true});
            }
          }; // $onInit()
          
          
          function removeShare(share) {
            share.active = false;
            share.$save();
          }
          
          vertxEventBusService.on('shares.update', function (message) {
            $log.debug('debug: share update received: ', message);
            let messages = message.split(':');
            vm.shares.$refresh().$then(function () {
              $log.debug('debug: sharelist refreshed shares');
            }, function (error) {
              $log.debug('debug: sharelist refresh shares failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());